import React from 'react';
import { FormatService } from 'src/js/common/utils/FormatUtils';
import { CreateStore, RestoreState } from './CreateStore';
import { Bootstrap } from './common/utils/Bootstrap';
import { configLoader } from './configLoader';
import { Level, Logger, LogMessage } from './services/Logger';
import { ConfigConstants } from './config/ConfigConstants';
import { WindowService } from './services/WindowService';
import { HTMLMarkers } from './common/services/HTMLMarker';
import { createRoot } from 'react-dom/client';
import { getPreferences } from './common/actions/Actions';
import { getCookie, setCookie } from './common/utils/Cookie';
import { v4 as uuid } from 'uuid';
import moment from 'moment-timezone';
import BrowserDetector from './common/utils/Browser';
import { LegacyModal } from './web/components/modal/LegacyModal';
import '../scss/index.scss';

// Babel polyfill
if (!(global as any)._babelPolyfill) {
  require('babel-polyfill');
}

// Intersection Observer polyfill
require('intersection-observer');

// Crypto polyfill
if ( !(window as any)?.crypto?.getRandomValues ) {
  (window as any).crypto = { getRandomValues: require('polyfill-crypto.getrandomvalues') };
}

// NodeList forEach polyfill
if (window.NodeList && !NodeList.prototype.forEach) {
  NodeList.prototype.forEach = Array.prototype.forEach as any;
}


// Log application version before start.
Logger.log(new LogMessage(Level.INFO, `Application version: "${ConfigConstants.APP_VERSION}"`));

const start = (store, persistor) => {
  WindowService.initCheckoutApi(store);

  // set initial dataLayer
  if (!(window as any).dataLayer) {
    (window as any).dataLayer = [];
  }

  // get global preferences
  store.dispatch(getPreferences());

  const react = new Bootstrap(store, persistor)
    .register(HTMLMarkers.CHECKOUT)
    .register(HTMLMarkers.SUGGESTIONS)
    .register(HTMLMarkers.FEES)
    .register(HTMLMarkers.ENROL_BUTTON)
    .register(HTMLMarkers.BUY_BUTTON)
    .register(HTMLMarkers.JOIN_BUTTON)
    .register(HTMLMarkers.CART)
    .register(HTMLMarkers.MODAL)
    .register(HTMLMarkers.POPUP)
    .register(HTMLMarkers.PROMOTIONS)
    .start();

  // Set bootstrap function to Ish.react
  // We use this in jquery-managed code,
  // to get notifications about new react-markers
  WindowService.set('react', react);
};

const appStart = () => {
  const isSupportedBrowser = new BrowserDetector().isSupported();

  if (!isSupportedBrowser) {
    const modalBody = document.createElement('div');
    document.body.append(modalBody);

    const root = createRoot(modalBody);

    root.render(
      <LegacyModal />
    );

    WindowService.get('modal')?.openModal({
      animation: 'slideUp',
      content: '<div style="\n' +
        '    padding: 40px;\n' +
        '    font-size: 24px;\n' +
        '">\n' +
        '    <p style="\n' +
        '    font-weight: bold;\n' +
        '"> Your current browser is not supported</p>Please ensure you are using an up to date version of Chrome, Firefox, Edge, Safari, Opera desktop or Internet Explorer 11</div>',
      duration: 600,
      height: 400,
      width: 1000
    });

    return;
  }


  setCookie(
    'clientTimezoneName',
    moment.tz.guess(true),
    {
      samesite: 'strict',
      secure: true,
    },
  );

  const cartId = getCookie('cartId');

  if (!cartId) {
    setCookie(
      'cartId',
      uuid().replace(/-/g, '').substring(0, 30),
      {
        secure: true
      }
    );
  }

  const store = CreateStore();

  configLoader(store);

  RestoreState(store, start);

  FormatService.setStore(store);
};

appStart();

